// pages/About.js
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';

export default function About() {
  return (
    <div className="page-wrapper">
      <Breadcrumbs
        items={[
          { to: '/disciplines', label: 'תחומי דעת' },
          { label: 'אודות' },
        ]}
      />

      <div className="toolbar-center">
        <h2 className="text-2xl md:text-3xl font-bold text-secondary-900 dark:text-white">
          אודות אתר הקודש במרכז
        </h2>
      </div>

      <p className="text-center mt-2 mb-6">
        <Link
          to="/disciplines"
          className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
        >
          חזרה לתחומי דעת
        </Link>
      </p>

      <div className="max-w-4xl mx-auto">
        <section className="bg-white dark:bg-secondary-800 rounded-2xl p-6 md:p-8 shadow-card">
          <div className="space-y-6 text-secondary-700 dark:text-secondary-300 leading-relaxed">
            <p>
              הוראת מקצועות הקודש נמצאת בלב העשייה החינוכית שלנו בחמ"ד. מעבר להעברת ידע, היא נושאת שליחות של עיצוב זהות, חיבור התלמידים לעולמה של תורה וחיזוק אמוני.
            </p>

            <p>
              האתר "הקודש במרכז" של מחוז חיפה הוקם עבורכם – מורי ומורות מקצועות הקודש – כדי שיהיה הבית שלכם לפדגוגיה מיטבית בהוראת הקודש.
            </p>

            <p>
              אתם המורים ניצבים יום יום מול אתגרים רבים. אנו רוצים להעניק לכם ליווי מקצועי מתמשך שיהיה בו השראה וגם מאגר כלים מעשיים לעבודתכם.
            </p>

            <p>
              לשם כך, ריכזנו באתר מגוון חומרים בכל אחד מארבעת תחומי הקודש:
            </p>

            <div className="space-y-4 mt-6">
              <div>
                <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                  תנ"ך
                </h3>
                <p>
                  בהובלת המדריך המחוזי הרב ד"ר ארי גייגר – יחידות הוראה המחברות בין פרקי המקרא לחיים האישיים של התלמידים, דרך סרטונים אקטואליים בצירוף עיבוד רגשי מעמיק בהקשר למקורות.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                  תורה שבעל פה
                </h3>
                <p>
                  בהובלת המדריך המחוזי הרב אפרים שרם שגם הקים ויצר את האתר - חומרי עזר ומרחבי הוראה עבור חטיבת הביניים, בדגש על הכנה למבחן המפמ"ר דרך לימוד חווייתי ורלוונטי.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                  מחשבת ישראל
                </h3>
                <p>
                  בהובלת המדריכה המחוזית רויטל הרמן – סרטוני הדרכה למורים להבנת מקורות החומר, לצד כלים פדגוגיים שיקרבו את התכנים ללב הלומדים.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                  רבני בתי הספר ומלוות רוחניות
                </h3>
                <p>
                  בהובלת המדריך המחוזי הרב יוסי קורט והרבנית ענבר אליהו - מגוון כלים חינוכיים ולימודיים לליווי הרוחני במוסדות החינוך.
                </p>
              </div>
            </div>

            <p className="mt-6">
              כל זאת בתוספת לאתרים המצוינים של המפמ"רים עפ"י תחומי הדעת.
            </p>

            <div className="my-8 space-y-4">
              <div>
                <p className="text-center italic text-lg">
                  "בַּרְזֶל בְּבַרְזֶל יָחַד, וְאִישׁ יַחַד פְּנֵי רֵעֵהוּ" (משלי כז, יז)
                </p>
              </div>

              <div>
                <p>
                  חז"ל במסכת תענית ז, ע"א מסבירים פסוק זה כך: "מה ברזל זה, אחד מחדד את חברו - אף שני תלמידי חכמים, מחדדין זה את זה בהלכה".
                </p>
              </div>
            </div>

            <p>
              האתר הוא מרחב חינוכי פתוח, חי, מתפתח ומעורר השראה – שבו עומק תורני נפגש עם יצירתיות וחדשנות פדגוגית.
            </p>

            <p>
              אנו מזמינים אתכם המורים והמורות להשתמש, לשתף, ליצור ולתרום משלכם כדי לחדד את הכלים שלכם מתוך למידת עמיתים
            </p>

            <p>
              וכך בעז"ה נזכה יחד להעמיד את הקודש במרכז העשייה בבתי החינוך, מתוך מקצועיות ושליחות גדולה.
            </p>

            <p className="font-semibold text-secondary-900 dark:text-white mt-6">
              בהצלחה רבה לכולנו!!
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
